module.exports = __webpack_public_path__ + "static/media/icon-RMS.2b211c17.svg";